<div mat-dialog-title>
  <span *ngIf="isSingle">{{ 'POPUPS.AUTHORISATION_SIGN_OFF' | translate }}</span>
  <span *ngIf="!isSingle">{{ 'POPUPS.AUTHORISATION_SIGN_OFF_ALL' | translate }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<q9-info-message *ngIf="error" type="error">
  '
  {{ error | translate }}
</q9-info-message>

<mat-dialog-content>
  <p *ngIf="!isSingle" class="modal-info">
    <span *ngIf="havePassword">{{ 'POPUPS.AUTHORISATION_SIGN_OFF_ALL_HINT_1' | translate }}</span>
    <span *ngIf="!havePassword">
      {{ 'POPUPS.AUTHORISATION_SIGN_OFF_ALL_HINT_1_SF' | translate }}
    </span>
    <br />
    <span>
      {{ 'POPUPS.AUTHORISATION_SIGN_OFF_ALL_HINT_2' | translate: {number: numberOfDiagrams} }}
    </span>
    <br />
  </p>
  <form [formGroup]="form" #formTemplate="ngForm">
    <q9-text-field
      *ngIf="havePassword"
      formControlName="password"
      type="password"
      [label]="'POPUPS.ENTER_PASSWORD'"></q9-text-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <q9-secondary-button mat-dialog-close>
    {{ 'VERSIONING.CANCEL_BTN' | translate }}
  </q9-secondary-button>
  <q9-primary-button [isLoading]="isLoading()" (click)="formTemplate.onSubmit($event); onSubmit()">
    <span *ngIf="isSingle">{{ 'VERSIONING.AUTHORISE' | translate }}</span>
    <span *ngIf="!isSingle">{{ 'POPUPS.SIGN_OFF_TASK' | translate }}</span>
  </q9-primary-button>
</mat-dialog-actions>
